// extracted by mini-css-extract-plugin
module.exports = {"xs":"idt-gap_xs__27gog","cell":"idt-gap_cell__1cow2","s":"idt-gap_s__13uhe","m":"idt-gap_m__3fxhw","l":"idt-gap_l__2u6cc"};